import React from "react";
import "./NotFound.css";

export default function NotFound() {
  return (
    <div className="NotFound">
      <h3>Lo sentimos, la página que buscas no está disponible!</h3>
    </div>
  );
}